import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPage } from './login.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginPage,
    data: {
      title: "Iniciar sesión"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginPageRoutingModule { }
